import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  forbiddenDescription: {
    id: 'pd.forbidden.product.description',
    defaultMessage:
      'Mrzí nás, že jste nenašli, co jste hledali. Věříme však, že si díky naší široké nabídce vyberete jiný produkt, který vám udělá radost.',
  },
});
